const styles = (theme) => ({
	explicacao: {
		p: 1.5,
		mb: 2,
		borderRadius: 2,
		border: `1px solid ${theme.palette.divider}`,
		backgroundColor: theme.palette.background.default,
	},
	linhaRegra: {
		display: "flex",
		alignItems: "flex-start",
		gap: 1,
		mb: 1,
	},
	// O select de sinal é curto e de largura fixa: a regex é que precisa de
	// espaço.
	campoSinal: {
		width: 130,
		flexShrink: 0,
	},
	blocoTeste: {
		mt: 3,
		p: 1.5,
		borderRadius: 2,
		border: `1px solid ${theme.palette.divider}`,
	},
	// Verdicto do testador: verde quando aparece, cinza quando não casa o tipo,
	// laranja quando casou mas o piso de severidade ocultou.
	veredito: (cor) => ({
		mt: 1.5,
		p: 1,
		borderRadius: 1,
		backgroundColor: `${cor}1f`,
		border: `1px solid ${cor}`,
	}),
	tituloVeredito: (cor) => ({
		fontWeight: 600,
		color: cor,
	}),
});

export default styles;
